import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { ChemicalAnchorMapping } from "../../../../http/concreteResin/types/chemicalAnchorMappings";
import useChemicalAnchorMappingsApi from "../../../../http/concreteResin/useChemicalAnchorMappings";
import { toDrillBitFraction, toUsDrillBitMillimeters } from "../resinUnits";
import ChemicalAnchorMappingForm from "./ChemicalAnchorMappingForm";

// The US drill bit for a metric hole, then its mm, what an imperial calculation's hole is:
// 13/32" (10.319 mm).
const formatUsDrillBit = (holeDiameter: number, unitMm: string): string => {
  const millimeters = toUsDrillBitMillimeters(holeDiameter);
  return `${toDrillBitFraction(millimeters)}" (${Number(millimeters.toFixed(3))} ${unitMm})`;
};

// No visibility nor order columns: a mapping follows its anchor's.
const AdminChemicalAnchorMappings: FC = () => {
  const i18n = useI18n();
  const resinTranslation = i18n.translation.concreteResinModule;
  const unitMm = i18n.translation.common.unitMm;
  const mappingsApi = useChemicalAnchorMappingsApi();

  return (
    <AdminCrudTable<ChemicalAnchorMapping>
      filterPrefix="anchor_mappings"
      useList={mappingsApi.useChemicalAnchorMappings}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.code}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.description}</TableHeadCell>
          <TableHeadCell align="left">{resinTranslation.rodDiameter}</TableHeadCell>
          <TableHeadCell align="left">{resinTranslation.holeDiameter}</TableHeadCell>
          <TableHeadCell align="left">{resinTranslation.holeDiameterImperial}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.chemicalAnchor.item.code}</TableCell>
          <TableCell>{item.chemicalAnchor.item.description}</TableCell>
          <TableCell>{`${item.rodDiameter} ${unitMm}`}</TableCell>
          <TableCell>{`${item.holeDiameter} ${unitMm}`}</TableCell>
          <TableCell>{formatUsDrillBit(item.holeDiameter, unitMm)}</TableCell>
        </>
      )}
      onDelete={(item) => mappingsApi.deleteChemicalAnchorMapping(item.id)}
      deleteTitle={resinTranslation.anchorMapping}
      canAdd
      renderForm={(item, onClose) => <ChemicalAnchorMappingForm mapping={item} onClose={onClose} />}
    />
  );
};

export default AdminChemicalAnchorMappings;
